<template>
    <div class="rounded-full text-white bg-tc-black-1 py-5 w-full font-semibold text-center cursor-pointer">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Backbtn',
    props:{
        isDisable:{
            type: Boolean,
            default: true
        }
    },
    data: function(){
        return{

        }
    },
    methods:{
        onclick: function(){
            this.$emit('onClick');
        }
    }
};
</script>

<style lang="scss" scoped>
.back{
    border-radius: 50%;
}
.back-icon{
    top: 7px;
    left: 8px;
}
</style>
